import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  WhenNull1z9qwiohnufo5 as WhenNull,
  notNullOrElse323gzwh5eb92x as notNullOrElse,
} from './NonNullModelCacheItem.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NoSuchSessionException2b4vf2qlyosw1 as NoSuchSessionException } from './currentSession.mjs';
import { CachedApi1lqobyokeihii as CachedApi } from './CachedApi.mjs';
import {
  ID2ebczrc12h07k as ID,
  UserRole_Admin_getInstance1ewshxr51h257 as UserRole_Admin_getInstance,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Notification1y91jemwm75tr as Notification } from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/notificationModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TCGNotification15rsix3sbs9g0 as TCGNotification } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/notifications.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_usersuhqswqrijs4 as get_user,
  get_createdAt1oxi5pjv9saww as get_createdAt,
} from '../../../../../lightning-server-notifications-shared/com/lightningkite/lightningserver/notifications/ModelFields-2090458501.mjs';
import {
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import {
  FamilyApplication2f6semoy1a9hz as FamilyApplication,
  ProviderApplicationj6elx51glw3 as ProviderApplication,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import {
  get_submissionxklyxsg05uep as get_submission,
  get_review35f4yosw8k9cn as get_review,
  get_submission3ha7ltsjel3fd as get_submission_0,
  get_reviewjqvgm91l8fp3 as get_review_0,
} from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { and3dbt2f202um49 as and } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class;
function sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0() {
  if (sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      invoke_naf6l2_k$() {
        return this.function_1().raw_1;
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, WhenNull()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0', VOID, VOID, [WhenNull(), FunctionAdapter()]);
    sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class = $;
  }
  return sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0Class;
}
function UserSession$self$lambda() {
  throw NoSuchSessionException().new_org_thecommunitygroupinc_cares_sdk_NoSuchSessionException_deyzch_k$();
}
var UserSessionClass;
function UserSession() {
  if (UserSessionClass === VOID) {
    class $ extends CachedApi() {
      constructor(api, userId) {
        super(api);
        this.api_1 = api;
        this.userId_1 = userId;
        var tmp = this;
        var tmp_0 = this.get_users_izsycf_k$().get_6ueaa7_k$(new (ID())(this.userId_1));
        var tmp_1 = UserSession$self$lambda;
        tmp.self_1 = notNullOrElse(tmp_0, new (sam$org_thecommunitygroupinc_cares_sdk_NonNullModelCacheItem_WhenNull$0())(tmp_1));
        var tmp_2 = this;
        tmp_2.isAdmin_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.self_1).role_1.compareTo_30rs7w_k$(UserRole_Admin_getInstance()) >= 0);
        var tmp_3 = this;
        tmp_3.managedFamilies_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.self_1).managesFamilies_1);
        var tmp_4 = this;
        tmp_4.managedProviders_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.self_1).managesProviders_1);
        var tmp_5 = this;
        tmp_5.managedLocations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.self_1).managesLocations_1);
        var tmp_6 = this;
        tmp_6.managedEmployers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.self_1).managesEmployers_1);
        var tmp_7 = this;
        tmp_7.managesFamilies_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$remember.invoke_r7m7el_k$(this.managedFamilies_1).isEmpty_y1axqb_k$();
        });
        var tmp_8 = this;
        tmp_8.managesProviders_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$remember.invoke_r7m7el_k$(this.managedProviders_1).isEmpty_y1axqb_k$();
        });
        var tmp_9 = this;
        tmp_9.managesLocations_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$remember.invoke_r7m7el_k$(this.managedLocations_1).isEmpty_y1axqb_k$();
        });
        var tmp_10 = this;
        tmp_10.managesEmployers_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$remember.invoke_r7m7el_k$(this.managedEmployers_1).isEmpty_y1axqb_k$();
        });
        var tmp_11 = this;
        tmp_11._myNotifications_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = this.get_notifications_jts33z_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
          var tmp$ret$6 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$6);
          var tmp_1 = eq(get_user(it), new (ID())(this.userId_1));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(Notification()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ID()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(TCGNotification()), arrayOf([]), false))]), false));
          var tmp$ret$13 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$13);
          this_0.descending_tl4o2_k$(get_createdAt(it_0));
          var tmp$ret$9 = this_0.build_1k0s4u_k$();
          return tmp.list$default_sjz00l_k$(new (Query())(tmp_1, tmp$ret$9, VOID, 100));
        });
        var tmp_12 = this;
        tmp_12.myNotifications_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(this._myNotifications_1)));
        var tmp_13 = this;
        tmp_13._pendingFamilyApplications_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = this.get_familyApplications_uxaw4w_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$15 = and(neq(get_submission(it), null), eq(get_review(it), null));
          var tmp_1 = new (Query())(tmp$ret$15, VOID, VOID, 200);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance();
          var tmp$ret$20 = toDuration(1, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_1, VOID, tmp$ret$20);
        });
        var tmp_14 = this;
        tmp_14.pendingFamilyInvites_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.isAdmin_1) ? $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(this._pendingFamilyApplications_1)).get_size_woubt6_k$() : 0);
        var tmp_15 = this;
        tmp_15._pendingProviderApplications_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = this.get_providerApplications_bz9fcz_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ProviderApplication()), arrayOf([]), false));
          var tmp$ret$23 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$23);
          var tmp$ret$21 = and(neq(get_submission_0(it), null), eq(get_review_0(it), null));
          var tmp_1 = new (Query())(tmp$ret$21, VOID, VOID, 200);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance();
          var tmp$ret$26 = toDuration(1, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_1, VOID, tmp$ret$26);
        });
        var tmp_16 = this;
        tmp_16.pendingProviderInvites_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.isAdmin_1) ? $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(this._pendingProviderApplications_1)).get_size_woubt6_k$() : 0);
      }
    }
    initMetadataForClass($, 'UserSession');
    UserSessionClass = $;
  }
  return UserSessionClass;
}
//region block: exports
export {
  UserSession as UserSessioncpstroni1zzl,
};
//endregion

//# sourceMappingURL=UserSession.mjs.map
